import { CustomFieldSearchOptions } from "../../enums/filters-and-searchs/CustomFieldFilterOptions";

export const CustomFieldSeachOptionsLabel = new Map<number, string>([
    [CustomFieldSearchOptions.Question, "Question"]
]);